import _ from "lodash";

const messageDetails = {
    conversationId: "",
    messageMapper: {},
};

/**
 * Clears the message details. This happens when the conversationId has changed.
 */
function clearMessageDetails() {
    messageDetails.conversationId = "";
    messageDetails.messageMapper = {};
}

/**
 * Checks to see if the conversationId has changed, if it has, set it to the new conversationId with a blank message mapper
 */
function checkAndHandleChange(conversationId) {
    if (conversationId !== messageDetails.conversationId) {
        messageDetails.conversationId = conversationId;
        messageDetails.messageMapper = {};
    }
}

/**
 * creates a new item if the topic does not exist. Else, it adds an item and runs a callback.
 * @param conversationId
 * @param topicName
 * @param message
 */
function addItem(conversationId, topicName, message) {
    checkAndHandleChange(conversationId);
    if (
        !messageDetails.messageMapper[topicName] ||
        !messageDetails.messageMapper[topicName].callbacks
    ) {
        messageDetails.messageMapper[topicName] = {
            message: message,
            callbacks: [],
        };
    } else {
        messageDetails.messageMapper[topicName].message = message;
        _.each(
            messageDetails.messageMapper[topicName].callbacks,
            function (callback) {
                callback(message);
            }
        );
    }
}

/**
 * Attaches callbacks
 * @param conversationId
 * @param topicName
 * @param callback
 */
function attachToItem(conversationId, topicName, callback) {
    checkAndHandleChange(conversationId);
    if (!messageDetails.messageMapper[topicName]) {
        messageDetails.messageMapper[topicName] = {
            message: null,
            callbacks: [callback],
        };
    } else {
        const message = messageDetails.messageMapper[topicName].message;
        if (typeof callback === "function") {
            if (message) {
                callback(message);
            }
            messageDetails.messageMapper[topicName].callbacks.push(callback);
        }
    }
}

export default {
    publish: addItem,
    subscribe: attachToItem,
    clear: clearMessageDetails,
};
